if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(event) {
        event.preventDefault();
        // Preventa V1 (dos CTAs): con dos <button type="submit"> dentro del
        // mismo <form>, this.querySelector('[type="submit"]') SIEMPRE
        // devolvía el primero, sin importar cuál se clickeó realmente --
        // event.submitter (SubmitEvent nativo) es el botón real. Fallback al
        // comportamiento anterior si por algún motivo submitter no viene
        // (ej. form.requestSubmit() sin argumento).
        const submitButton = event.submitter || this.querySelector('[type="submit"]');
        // Hardening (revisión defensiva): guard extra si por cualquier
        // motivo no hay NINGÚN botón submit en el form (no debería ocurrir
        // -- todo <product-form> real tiene al menos uno -- pero evita un
        // TypeError si algún caller futuro renderiza el form sin botón).
        if (!submitButton) {
          return;
        }
        if (submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        const submitButtonSpinner = submitButton.querySelector(".button-overlay-spinner");
        if (submitButtonSpinner) {
          submitButtonSpinner.classList.remove("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.minicart.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(this.getSafeCartErrorMessage(response));
              this.minicart.updateSectionContents();
              return;
            }

            this.minicart.renderContents(response);

            // Preventa V1 (dos CTAs): el botón "Comprar en Preventa" fuerza
            // redirección al carrito vía data-pm-redirect-cart, reutilizando
            // el MISMO mecanismo nativo de redirect-to-cart (no uno nuevo) --
            // sin depender de/alterar window.themeSettings.redirectToCart,
            // que sigue gobernando el comportamiento global normal del theme.
            const forceRedirectToCart = submitButton.hasAttribute("data-pm-redirect-cart");
            if (window.themeSettings.redirectToCart || forceRedirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              if (this.quickViewDrawer) {
                this.quickViewDrawer.close();
                // Immediately re-add the 'drawer-open' class to avoid
                // the drawer backdrop from flashing.
                document.body.classList.add("drawer-open");
                setTimeout(() => this.minicart.open(), 200);
              } else {
                this.minicart.open(submitButton);
              }
            }

            const event = new CustomEvent("cart:item-add", {
              detail: {
                items: [response],
                context: this.eventContext,
              },
            });
            document.dispatchEvent(event);

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            if (submitButtonSpinner) {
              submitButtonSpinner.classList.add("hidden");
            }
          });
      }

      // PM 20-10-2026 (auditoría Ric): los errores 422 de /cart/add.js traen
      // en description el stock real ("solo se añadieron N artículos").
      // Se muestra un mensaje sin cantidades para no exponer el inventario.
      getSafeCartErrorMessage(response) {
        if (response && response.status === 422) {
          return "No hay suficientes unidades disponibles para compra online. Revisa la cantidad en tu carrito o escríbenos por WhatsApp si necesitas más.";
        }
        return response.description;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
